import React from 'react';
import MyBadges from './MyBadges';
import Dashboard from './Dashboard';
import Leaderboard from './Leaderboard';
import {Aws} from '../../assets/img';


// import styles from '../../assets/styles/custom.css';



export default class Home extends React.Component {
    
    render(routeProps) {
        return (
            <div>
                <div className="home-header">
                    <div className="awsui-grid awsui-util-p-s">
                        <div className="awsui-row">
                            <div className="title-box">
                                <img className="home-logo" src={Aws} alt="aws" />
                                <div className="awsui-text-large"><strong>Bottlenose</strong>
                                </div>
                                
                                



                                <div><p className="home-header-description awsui-util-p-n">A hands-on and gamified approach to problem-solving. </p></div>
                                {/* <div className="awsui-text-large">Bottlenose v1.0: A library of frontend and design resources</div> */}
                            </div>
                            <MyBadges/>
                        </div>
                    </div>
                </div>

                <div className="home-content">
                    <Dashboard {...routeProps} {...this.props} />
                    <Leaderboard {...routeProps} {...this.props} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Home.jsx